import { PureComponent } from "react"
import classNames from "classnames"
import Link from "next/link"

import Icon from "../icon/icon"

import "./cta.scss"

class   Cta extends PureComponent {
  onClick = () => this.props.onClick({ ...this.props.args })

  render() {
    const {
      type,
      tag,
      text,
      link,
      bgColor,
      basic,
      icon,
      darkText,
      disabled,
      isExternalLink,
      loading,
      modifierClass,
      hasRef,
      month,
      TagBadge,
      className,
      commanBtnclass=""
    } = this.props

    const isWhiteBg = bgColor === "white"

    return (
      <div
        className={classNames("cta", {
          ["cta--white"]: isWhiteBg,
          ["cta--basic"]: basic,
          [`cta--icon cta--icon--${icon}`]: icon,
          ["cta--dark-text"]: darkText,
          [`cta--${modifierClass}`]: modifierClass,
          ["cta--loading"]: loading,
          [`${className}`]: className,
        })}
      >
        <div className="cta__inner">
          {tag === "button" && (
            <button
              className={classNames("commanBtn", commanBtnclass)}
              disabled={disabled}
              type={type}
              {...(this.props.onClick && { onClick: this.onClick })}
            >
              <span className="cta__text">
                {text}
                {month && <small>{month}</small>}
              </span>
              {TagBadge && <div className="tagBadge">{TagBadge}</div>}
              {loading &&
                (isWhiteBg ? (
                  <Icon
                    modifierClass="spinner-cta"
                    iconUrl="/static/icons/spinner.svg"
                  />
                ) : (
                  <Icon
                    modifierClass="spinner-cta"
                    iconUrl="/static/icons/spinner-white.svg"
                  />
                ))}
            </button>
          )}
          {tag === "link" && (
            <>
              {isExternalLink ? (
                <a
                  className={classNames("cta__link", className)}
                  target="_blank"
                  href={`${link}${hasRef ? "?ref=starthawk" : ""}`}
                  rel="noopener noreferrer"
                >
                  {text}
                </a>
              ) : (
                <Link href={link}>
                  <a className={classNames("cta__link", className)}>
                    <span>{text}</span>
                    {loading &&
                      (isWhiteBg ? (
                        <Icon
                          modifierClass="spinner-cta"
                          iconUrl="/static/icons/spinner.svg"
                        />
                      ) : (
                        <Icon
                          modifierClass="spinner-cta"
                          iconUrl="/static/icons/spinner-white.svg"
                        />
                      ))}
                  </a>
                </Link>
              )}
            </>
          )}
        </div>
      </div>
    )
  }
}

Cta.defaultProps = {
  disabled: false,
  loading: false,
}

export default Cta
